/**
 * A catalog item's lifecycle, the same members as `CatalogItemStatus` on `catalog_items`.
 * Almost every item stays STANDARD. PRE_RELEASE holds an item for a box that has not launched.
 * ARCHIVED retires it. A test in core keeps this list equal to that enum.
 */
export const CATALOG_ITEM_STATUSES = ["STANDARD", "PRE_RELEASE", "ARCHIVED"] as const;
export type CatalogItemStatusName = (typeof CATALOG_ITEM_STATUSES)[number];

/**
 * Who may use a catalog item, the same members as `Circulation` on `catalog_items`.
 * Staff set one of these as an override; unset leaves the policy value. A test in core keeps
 * this list equal to that enum.
 */
export const CIRCULATION_OVERRIDES = ["OPEN", "OFFICIAL_ONLY"] as const;
export type CirculationName = (typeof CIRCULATION_OVERRIDES)[number];
